<template>
  <div>
    <form v-if="!loading" class="nameform" @submit="next">
      <div class="content">
        <h1 class="mb-6 text-center big-title">
          Conferma la richiesta carta
        </h1>

        <p class="text-center">
          Inserisci il mobile token
        </p>
        <div class="mt-10">
          <VerifyCode @onUpdate="v => (code = v)" />
        </div>
        <hr class="my-10" />
        <div class="md:text-center">
          <div v-if="!smsSent">
            <p class="mb-3 f-m">Non hai ricevuto il mobile token?</p>
            <div v-if="isDesktopOrAndroid()" class="flex items-center mb-5">
            <img width="20" src="../../assets/images/idea.png" style="margin-left: -4px;">
            <p class="ml-2 f-r" style="font-size: 12px;color: #585858;">Controlla anche nello SPAM dei tuoi SMS</p>
          </div>
            <div @click="resendSms" class="mb-8 link">
              Richiedi un nuovo codice
            </div>
          </div>
          <div v-else>
            <p style="color: #57B268" class="mb-3 f-m">SMS inviato!</p>
            <div class="mb-8 text-grey">
              Controlla sul tuo dispositivo
            </div>
          </div>
        </div>
      </div>

      <div class="page-footer">
        <button
          class="btn desktop-only"
          :disabled="code.length < 6"
          @click="next"
        >
          Prosegui
        </button>
      </div>
      <NumericPad renderButton="true">
        <button class="btn" :disabled="code.length < 6" type="submit">
          Prosegui
        </button>
      </NumericPad>
    </form>
    <SignatureLoader
      title="Stiamo elaborando la tua firma"
      :steps="[
        'Modulo di richiesta dei servizi di firma elettronica infocert',
        'Documentazione Banca Profilo',
        'Modulo di richiesta carta prepagata'
      ]"
      v-else
      :loadingLevel="loadingLevel"
    />
    <Modal id="modalMinorBalanceError" title="Addebito non riuscito">
      <template v-slot:content>
        <img
          src="../../assets/images/bloccoApp.png"
          style="max-width: 150px; margin: 0px auto 20px;"
        />
        <p class="mb-10">
          Non siamo riusciti ad addebitare la quota necessaria e quindi non è
          avvenuto il rilascio della nuova carta.
        </p>
      </template>

      <template v-slot:buttons>
        <button class="btn" @click="p2pToMinor" type="button">
          Trasferisci l'importo necessario
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import VerifyCode from "@/components/VerifyCode";
import NumericPad from "@/components/NumericPad";
import SecurityService from "@/services/SecurityService";
import UtilityService from "@/services/UtilityService";
import RegistrationService from "@/services/RegistrationService";
import SignatureLoader from "@/modules/SignatureLoader";
import Modal from "@/components/Modal.vue";

export default {
  name: "ConfirmSms",
  components: {
    VerifyCode,
    NumericPad,
    SignatureLoader,
    Modal
  },
  data() {
    return {
      code: "",
      loading: false,
      loadingLevel: 0,
      smsSent: false,
      user: this.$store.state.user,
      registration: this.$store.state.registrations
    };
  },
  mounted() {
    this.$root.$on("openedNumericPad", this.openedNumericPad);
  },
  methods: {
    p2pToMinor() {
      UtilityService.p2pToMinor({
        userId: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        registrationId: this.registration.id,
        prepaidCardResource: this.registration.prepaidCardResource
      });
    },
    resendSms() {
      RegistrationService.sendOtp().then(
        () => {
          this.smsSent = true;
          setTimeout(() => {
            this.smsSent = false;
          }, 60000);
        },
        () => {
          UtilityService.showErrorModal(
            "Non è stato possibile inviare un nuovo SMS. Per maggiori informazioni contattaci"
          );
        }
      );
    },
    openedNumericPad() {
      UtilityService.scrollTopPage();
    },
    backToPinCode(error) {
      this.$router.push({
        name: "TutorConfirmAccessCode",
        params: {
          skipNewToken: true,
          errors: error
        }
      });
      this.$root.$emit("changedRoute");
    },
    addOnBeforeUnloadAlert() {
      this.$route.meta.userCantGoBack = true;
      history.pushState(null, document.title, location.href);
      window.addEventListener("popstate", this.disableBack);
      window.onbeforeunload = window.onbeforeunload = function() {
        return "Sei sicuro di voler eseguire nuovamente il caricamento della pagina? Se confermi il processo potrebbe essere interrotto e le informazioni potrebbero non essere salvate";
      };
    },
    removeOnBeforeUnloadAlert() {
      this.$route.meta.userCantGoBack = false;
      window.removeEventListener("popstate", this.disableBack);
      window.onbeforeunload = function() {};
    },
    isDesktopOrAndroid() {
      return UtilityService.isDesktopOrAndroid();
    },
    disableBack() {
      history.pushState(null, document.title, location.href);
    },
    startInfocertSignStatusPolling() {
      //Settings
      const pollingDelayInSeconds = 2,
        timeoutInSeconds = 300;

      return new Promise(function(resolve, reject) {
        let timer = timeoutInSeconds;
        let verified = false;
        let errorFound = false;
        let interval = setInterval(() => {
          if (verified) {
            clearInterval(interval);
            resolve();
          } else if (errorFound) {
            clearInterval(interval);
            UtilityService.showErrorModal();
            reject("GENERIC_ERROR");
          } else if (timer <= 0) {
            clearInterval(interval);
            //custom handler for timeout?
            UtilityService.showErrorModal();
            reject("TIMED_OUT_CLIENT");
          } else pollingRequest();
          timer -= pollingDelayInSeconds;
        }, pollingDelayInSeconds * 1000);

        const pollingRequest = () => {
          RegistrationService.getSignatureStatus().then(
            response => {
              if (response.data.infocertSignRunning === false) verified = true;
            },
            () => {
              errorFound = true;
            }
          );
        };
      });
    },
    startLoaderPage() {
      this.loading = true;
      this.addOnBeforeUnloadAlert();

      this.loadingLevel = 0;

      setTimeout(() => {
        const $pageElement = document.querySelector(".page");
        $pageElement.scrollTop = 0;
      }, 100);

      setTimeout(() => {
        this.loadingLevel = 1;
      }, 2000);

      setTimeout(() => {
        this.loadingLevel = 2;
      }, 7000);
    },
    doneRegistration() {
      this.loadingLevel = 3;

      setTimeout(() => {
        this.loading = false;
        this.removeOnBeforeUnloadAlert();
        this.$root.$emit("submitStep");
      }, 1000);
    },
    async next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;

      this.startLoaderPage();
      try {
        await SecurityService.verifyIcOtp({
          otp: this.code,
          password: this.$store.state.user.confirmAccessCode
        });

        const infocertData = {
          sessionKey: this.$store.state.user.infocert.sessionKey,
          taskId: this.$store.state.user.infocert.taskId,
          documents: this.$store.state.user.clauses
            .filter(d => d.id === "ID503")
            .map(d => {
              return { id: d.id, acceptedTerms: d.signatures.map(s => s.id) };
            }),

          flow: "PREPAID_CARD_MINOR",
          step: 5
        };

        if (this.$store.state.user.infocert.valid) {
          infocertData.valid = true;
        }

        await RegistrationService.sign(infocertData);

        this.doneRegistration();
      } catch (error) {
        this.removeOnBeforeUnloadAlert();
        console.log(error);
        const context =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.context
            ? error.response.data.context
            : {};

        const errorCode = context.code || "";

        switch (errorCode) {
          case "WAL_010012":
            this.$root.$emit("openModal", "modalMinorBalanceError");
            break;

          case "SEC_SEC_0005":
          case "SEC_SEC_0021":
            this.backToPinCode({
              pinCode:
                "Il codice di accesso e/o il mobile token inseriti non sono corretti. Verificali e riprova"
            });
            break;

          default:
            UtilityService.showDefaultError(error);

            break;
        }

        this.loading = false;
      }
    }
  }
};
</script>
